import { Store } from '../../../store/player/types';

/**
 * Clear next recording countdown timeout.
 */
export const cancelNextRecordingCountdown = (store: Store): void => {
  const { nextRecordingCountdown, setCancelledNextRecordingCountdown } = store.getState();

  setCancelledNextRecordingCountdown(true);
  clearTimeout(nextRecordingCountdown as number);
};
